import {
    getAdvanced,
    getBackgroundImages,
    getVerticalAlignment,
    readInlineStyleValue
} from '../../utils'

const configAggregator = (node) => {
    return {
        minHeight: readInlineStyleValue(node.style.minHeight) ?? null,
        display: readInlineStyleValue(node.style.display),
        width: readInlineStyleValue(node.style.width),
        backgroundColor: readInlineStyleValue(node.style.backgroundColor),
        ...getAdvanced(node),
        ...getBackgroundImages(node),
        ...getVerticalAlignment(node)
    }
}

export default configAggregator
